export default __webpack_public_path__ + "static/media/logo.27537982.png";